/**
 * The server refuses a text to a customer who opted out with a `failed-precondition` error whose
 * message starts with "Blocked:". Staff must SEE that message: a generic "Failed to send, please try
 * again" invites a tech to retry, or to text the customer from a personal phone.
 */
export function blockedSmsMessage(err: unknown): string | null {
  if (typeof err !== 'object' || err === null) return null;
  const { code, message } = err as { code?: unknown; message?: unknown };
  if (typeof code !== 'string' || !code.endsWith('failed-precondition')) return null;
  if (typeof message !== 'string' || !message.startsWith('Blocked:')) return null;
  return `${message}. Do not text this customer from another phone; call them instead.`;
}

/**
 * The server refuses the same text to the same customer twice in two minutes (`already-exists`, message
 * starts "Duplicate text:"), and tells us when Dialpad did not confirm a send (`deadline-exceeded`,
 * "Not confirmed:"). Staff must SEE those words: the generic "Failed to send SMS. Please try again."
 * is exactly what makes a person send a customer the same text again (ISS-605). The prefix is checked
 * as well as the code so an unrelated timeout from the network layer keeps the generic message.
 */
export function duplicateSmsMessage(err: unknown): string | null {
  if (typeof err !== 'object' || err === null) return null;
  const { code, message } = err as { code?: unknown; message?: unknown };
  if (typeof code !== 'string' || typeof message !== 'string') return null;
  if (code.endsWith('already-exists') && message.startsWith('Duplicate text:')) return message;
  if (code.endsWith('deadline-exceeded') && message.startsWith('Not confirmed:')) return message;
  return null;
}
